import { DatePicker, Form, Input, Select } from "antd";

// The staff master form, shared by the create modal (StaffListPage) and the edit modal
// (StaffDetailPage) so the two cannot drift apart. The identity fields mirror the client's
// HR register: a local employee has a national ID number, a foreign worker a passport and
// work permit; all are optional because the form is also how a bare record gets created.
export function StaffFormFields({ editing = false }: { editing?: boolean }) {
  return (
    <>
      <Form.Item name="staffCode" label="Staff code" rules={[{ required: true }]}>
        <Input disabled={editing} />
      </Form.Item>
      <Form.Item name="name" label="Name" rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      <Form.Item name="designation" label="Designation">
        <Input />
      </Form.Item>
      <Form.Item name="nationality" label="Nationality">
        <Input />
      </Form.Item>
      <Form.Item name="idNumber" label="ID number">
        <Input />
      </Form.Item>
      <Form.Item name="passportNumber" label="Passport number">
        <Input />
      </Form.Item>
      <Form.Item name="workPermitNumber" label="Work permit number">
        <Input />
      </Form.Item>
      <Form.Item name="joinDate" label="Join date">
        <DatePicker style={{ width: "100%" }} />
      </Form.Item>
      <Form.Item name="employmentStatus" label="Employment status" initialValue="ACTIVE">
        <Select
          options={[
            { value: "ACTIVE", label: "Active" },
            { value: "INACTIVE", label: "Inactive" },
          ]}
        />
      </Form.Item>
      <Form.Item name="notes" label="Notes">
        <Input.TextArea rows={2} />
      </Form.Item>
    </>
  );
}
